export default "__VITE_ASSET__B9lu0P9O__"